import * as a from "./actions";
import * as m from "./mutations";

import _ from "lodash";

import Vue from "vue";
import { FetchOptionsCommand } from "@/model/communication/options/FetchOptionsCommand";
import { ReloadOptionsCommand } from "@/model/communication/options/ReloadOptionsCommand";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { SaveOptionsCommand } from "@/model/communication/options/SaveOptionsCommand";
import state from "./state";

export default {
    state,
    mutations: {
        [m.SET_OPTIONS](state, payload) {
            Vue.set(state, "options", [...payload]);
        },
    },
    actions: {
        async [a.FETCH_OPTIONS]({ commit }) {
            const res = await new FetchOptionsCommand().execute();

            if (res.status == 200 && res.data.Response == 0) {
                commit(m.SET_OPTIONS, res.data.Payload);
            }
        },

        async [a.SAVE_OPTIONS]({ dispatch, state }) {
            let response: ApiGenericResponse = await new SaveOptionsCommand(state.options).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                dispatch(a.FETCH_OPTIONS);
            }
        },
        async [a.RELOAD_FROM_FILE]({ dispatch }) {
            let response: ApiGenericResponse = await new ReloadOptionsCommand().execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                dispatch(a.FETCH_OPTIONS);
            }
        },
    },
    getters: {
        optionsTree: (state) => {
            return _.groupBy(state.options, "Section");
        },

        localeFromOptions: (state) => {
            var result = null;
            state.options.forEach((op) => {
                if (op.Section == "OPTIONS" && op.Id == "language") {
                    result = op.Value;
                }
            });
            return result;
        },

        notificationsEnable: (state) => {
            var result = null;
            state.options.forEach((op) => {
                if (op.Section == "UC_NOTIFICATIONS" && op.Id == "enable") {
                    result = op.Value;
                }
            });
            return result;
        },

        notificationsPollingIntervalSec: (state) => {
            var result = null;
            state.options.forEach((op) => {
                if (op.Section == "UC_NOTIFICATIONS" && op.Id == "pollingInterval") {
                    result = op.Value * 1000;
                }
            });

            return result;
        },
    },
};
